var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "back-profile",
        {
          nativeOn: {
            click: function($event) {
              return _vm.navigateTo("app.profile.home")
            }
          }
        },
        [_vm._v("Perfil de " + _vm._s(_vm.studentProfile.student.name))]
      ),
      _vm._v(" "),
      _c(
        "block",
        [
          _c("template", { slot: "header" }, [
            _vm._v("Alertas (" + _vm._s(_vm.activeAlerts.length) + ")")
          ]),
          _vm._v(" "),
          _c("template", { slot: "actions" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary is-outlined",
                on: {
                  click: function($event) {
                    return _vm.navigateTo("app.profile.raise_alert")
                  }
                }
              },
              [_vm._v("\n        + Agregar\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("item-list", {
            attrs: { items: _vm.activeAlerts, "key-field": "id" },
            on: { "item-selected": _vm.goToAlert },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(_vm._s(_vm.alertTitle(item)))]
                }
              },
              {
                key: "description",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _vm._v(_vm._s(_vm._f("humanizeDate")(item.createdAt)))
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "block",
        [
          _c("template", { slot: "header" }, [_vm._v("Alertas cerradas")]),
          _vm._v(" "),
          _vm.inactiveAlerts.length
            ? _c("item-list", {
                attrs: { items: _vm.inactiveAlerts, "key-field": "id" },
                on: { "item-selected": _vm.goToAlert },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function(ref) {
                        var item = ref.item
                        return [_vm._v(_vm._s(_vm.alertTitle(item)))]
                      }
                    },
                    {
                      key: "description",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm._v(_vm._s(_vm._f("humanizeDate")(item.createdAt)))
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2664238879
                )
              })
            : _c("p", [_vm._v("Sin registros.")])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }